import React from "react";
import Box from "@mui/material/Box";
import useIsMobile from "@app.automotus.io/components/hooks/useIsMobile";
import { PermitApplicationStep, usePermitApplicationContext } from "../../PermitApplicationContext";
import { MobileStepper } from "./MobileStepper";
import { DesktopStepper } from "./DesktopStepper";

export interface PermitApplicationStepperProps {
  currentStep: PermitApplicationStep;
  onStepClick?: (step: PermitApplicationStep) => void;
}

export const PermitApplicationStepper: React.FC<PermitApplicationStepperProps> = ({ currentStep, onStepClick }) => {
  const isMobile = useIsMobile();
  const { isStepComplete, canProceedToStep } = usePermitApplicationContext();

  const handleStepClick = (step: PermitApplicationStep) => {
    if (onStepClick && canProceedToStep(step)) {
      onStepClick(step);
    }
  };

  return (
    <Box sx={{ mb: { xs: 3, md: 4 } }}>
      {isMobile ? (
        <MobileStepper currentStep={currentStep} />
      ) : (
        <DesktopStepper
          currentStep={currentStep}
          isStepComplete={isStepComplete}
          canProceedToStep={canProceedToStep}
          onStepClick={handleStepClick}
        />
      )}
    </Box>
  );
};

export default PermitApplicationStepper;
